import { memo, useEffect, useState } from "react";

import { Typography ,useMediaQuery} from "@mui/material";

import NavGroup from "./NavGroup";

import { useTheme } from "@mui/material/styles";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  getNotification,
  notificationAlert,
  getUnreadData,
} from "store/slices/notificationAction";
import { getAllChat } from "store/slices/firebaseAction";
import { getPropertyRequestNotification } from "store/slices/propertyRequestAction";
import { getStaffSupportNotification } from "store/slices/staffSupportAction";
import { useLocation } from "react-router-dom";
// assets

import {
  IconUserCheck,
  IconLanguage,
  IconMessageLanguage,
  IconBuildingHospital,
  IconBuildingCommunity,
  IconUsers,
  IconUserCircle,
  IconLicense,
  IconBuildingSkyscraper,
  IconClipboardList,
  IconDeviceAnalytics,
  IconMessages,
  IconMail,
  IconHelp,
  IconHome,
  IconSettings,
  IconParking,
  IconLetterT,
  IconBuildingCarousel,
  IconReceipt,
  IconShoppingCart,
  IconAd,
  IconUserSquare,IconDeviceNintendo
} from "@tabler/icons";
import RttIcon from '@mui/icons-material/Rtt';
import ViewCompactAltIcon from '@mui/icons-material/ViewCompactAltOutlined';
import useRecursiveTimeout from "../MenuList/useRecursiveTimeout";

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (props) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("sm"));
  const { adminLabelsName } = props.label;
  const { getNotification } = props;
  const role = localStorage.getItem("role");
  const location = useLocation();
  const [callingValue, setCallingValue] = useState(1);
  const [unread, setUnread] = useState(0);
  const [unreadNotification, setUnreadNotification] = useState(0);
  const [unreadChats, setunreadChats] = useState(0);
  const [staffSupportUnread, setStaffSupportUnread] = useState(0);
  const notifications = useSelector((state) => state.notifications);
  const { loading, notificationList, notificationData } = notifications;
  // const propertyRequest = useSelector((state) => state.propertyRequest);
  // const { propertyRequestList } = propertyRequest;
  // const unread = propertyRequestList;
  const [page, setPage] = useState(1);
  const unreads = notificationData;
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const chatState = useSelector((state) => state.chats.chats);

  // useEffect(() => {
  //   props.getAllChat("").then((res) => {
  //     const a = chatState.filter((val) => val.last && val.last.flag !== 1);
  //     if (a?.length > 0) {
  //       let b = 0;
  //       for (let i = 0; i < a.length; i++) {
  //         let tempObj = a[i];
  //         if (tempObj.hasOwnProperty("unreads")) {
  //           b = b + tempObj.unreads;
  //         }
  //       }
  //       setunreadChats(b);
  //     }
  //   });
  // }, []);
  // useRecursiveTimeout(async () => {
  //   props.getAllChat("").then((res) => {
  //     const a = chatState.filter((val) => val.last && val.last.flag !== 1);
  //     if (a?.length > 0) {
  //       let b = 0;
  //       for (let i = 0; i < a.length; i++) {
  //         let tempObj = a[i];
  //         if (tempObj.hasOwnProperty("unreads")) {
  //           b = b + tempObj.unreads;
  //         }
  //       }
  //       setunreadChats(b);
  //     }
  //   });
  // }, 10000);

  // useEffect(() => {
  //   let z;
  //   if (chatState.length > 0) {
  //     for (let i = 0; i < chatState.length; i++) {
  //       let tempObj = chatState[i];
  //       if (tempObj.hasOwnProperty("unreads")) {
  //         setunreadChats(tempObj.unreads);
  //         z = tempObj.unreads;
  //         break;
  //       }
  //     }
  //   }
  // }, [chatState, unreadChats]);

  // useEffect(() => {
  //   props.getUnreadData();
  // }, []);

  // useRecursiveTimeout(async () => {
  //   props.getUnreadData();
  // }, 10000);

  // useEffect(() => {
  //   props.getNotification(1, 20, "");
  // }, []);

  // useRecursiveTimeout(async () => {
  //   getNotification(1, 20, "").then((res) => {
  //     setUnreadNotification(res.unread);
  //   });
  // }, 10000);

  // useEffect(() => {
  //   props.getPropertyRequestNotification().then((res) => {
  //     setUnread(res.unread);
  //   });
  // }, []);

  // useRecursiveTimeout(async () => {
  //   props.getPropertyRequestNotification().then((res) => {
  //     setUnread(res.unread);
  //   });
  // }, 10000);

  // useEffect(() => {
  //   props.getStaffSupportNotification().then((res) => {
  //     setStaffSupportUnread(res.unread);
  //   });
  // }, []);

  // useRecursiveTimeout(async () => {
  //   props.getStaffSupportNotification().then((res) => {
  //     setStaffSupportUnread(res.unread);
  //   });
  // }, 10000);



  // if (location.pathname === "/notification" && callingValue < 8) {
  //   setTimeout(() => {
  //     setCallingValue(callingValue + 1);
  //     const notify = [];
  //     let b = notificationList.docs.length;
  //     for (let i = 0; i < b; i++) {
  //       notify.push(notificationList.docs[i]._id);
  //     }
  //     let datas = { id: notify, flag: 2 };
  //     props.notificationAlert(datas);

  //     props.getUnreadData();
  //   }, 50000);
  // }
  //  notificationList.docs.map((note)=>(

  //  ))

  // let eee={"id":notify,"f":2}

  // useEffect(() => {

  //   const notify = [];
  //   let b = notificationList.docs.length;
  //   for (let i = 0; i < b; i++) {
  //     notify.push(notificationList.docs[i]._id);
  //   }
  //   if (location.pathname === "/notification") {
  //     let datas = { id: notify, flag: 2 };
  //     props.notificationAlert(datas);

  //   }
  // }, [location.pathname === "/notification"]);

  const other = {
    id: "sample-docs-roadmap",
    type: "group",
    role: "Admin",
    children: [

  
     
      {
        id: "Users",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_users").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_users")[0][
                      "value"
                    ] || "lbl_users"
                  : "lbl_users"
                : "lbl_users"
            }
          />
        ),
        type: "collapse",
       
        icon: IconUsers,
        breadcrumbs: false,
        children:[
          {
            id: "Tenants",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_tenants").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_tenants")[0][
                          "value"
                        ] || "lbl_tenants"
                      : "lbl_tenants"
                    : "lbl_tenants"
                }
              />
            ),
            type: "item",
            url:"/users",
            icon: IconUserCheck,
            breadcrumbs: false,
          },
          {
            id: "Property Owner",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_landlords")
                        .length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_landlords")[0][
                          "value"
                        ] || "lbl_landlords"
                      : "lbl_landlords"
                    : "lbl_landlords"
                }
              />
            ),
            type: "item",
            url: "/property-owner",
            icon: IconUserCircle,
            breadcrumbs: false,
          },
        ]
      },
      {
        id: "Properties",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_properties_management").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_properties_management")[0][
                      "value"
                    ] || "lbl_properties_management"
                  : "lbl_properties_management"
                : "lbl_properties_management"
            }
          />
        ),
        type: "collapse",
    
        icon: IconBuildingSkyscraper,
        breadcrumbs: false,
        children: [
          {
            id: "registerProperties",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_register_new_property").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_register_new_property")[0][
                          "value"
                        ] || "lbl_register_new_property"
                      : "lbl_register_new_property"
                    : "lbl_register_new_property"
                }
              />
            ),
            type: "item",
            url: "/property/register",
            icon: IconHome,
            breadcrumbs: false,
          },
         
          {
            id: "AgencyRent",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_agency_rent").length >
                      0
                      ? adminLabelsName.filter((e) => e.key == "lbl_agency_rent")[0][
                          "value"
                        ] || "lbl_agency_rent"
                      : "lbl_agency_rent"
                    : "lbl_agency_rent"
                }
              />
            ),
            type: "item",
            url: "/agency-rent",
            icon: IconReceipt,
            breadcrumbs: false,
          },
          {
            id: "Property Request",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_properties_request")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_properties_request"
                        )[0]["value"] || "lbl_properties_request"
                      : "lbl_properties_request"
                    : "lbl_properties_request"
                }
              />
            ),
            type: "item",
            url: "/property-request",
            icon: IconBuildingSkyscraper,
            breadcrumbs: false,
            chip: {
              label: unread,
              color: "primary",
            },
          },
          {
            id: "Rental Contract",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_rental_contract")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_rental_contract"
                        )[0]["value"] || "lbl_rental_contract"
                      : "lbl_rental_contract"
                    : "lbl_rental_contract"
                }
              />
            ),
            type: "item",
            url: "/rental-contract",
            icon: IconLicense,
            breadcrumbs: false,
          },
          {
            id: "Reported Properties",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_reported_properties")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_reported_properties"
                        )[0]["value"] || "lbl_reported_properties"
                      : "lbl_reported_properties"
                    : "lbl_reported_properties"
                }
              />
            ),
            type: "item",
            url: "/reported-properties",
            icon: IconBuildingCommunity,
            breadcrumbs: false,
          },
          {
            id: "Property Field",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_property_field")
                        .length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_property_field")[0][
                          "value"
                        ] || "lbl_property_field"
                      : "lbl_property_field"
                    : "lbl_property_field"
                }
                // id="Property Field"
              />
            ),
            type: "item",
            url: "/property-field",
            icon: IconBuildingCarousel,
            breadcrumbs: false,
          },
        ]
      },
      {
        id: "Control",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_control").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_control")[0][
                      "value"
                    ] || "lbl_control"
                  : "lbl_control"
                : "lbl_control"
            }
          />
        ),
        type: "collapse",
       
        icon: IconDeviceNintendo,
        breadcrumbs: false,
        children:[
        {
          id: "Analytics",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_analytics").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_analytics")[0][
                        "value"
                      ] || "lbl_analytics"
                    : "lbl_analytics"
                  : "lbl_analytics"
              }
            />
          ),
          type: "item",
          url: "/analytics",
          icon: IconDeviceAnalytics,
          breadcrumbs: false,
        },
        {
          id: "text",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_text_and_language").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_text_and_language")[0][
                        "value"
                      ] || "lbl_text_and_language"
                    : "lbl_text_and_language"
                  : "lbl_text_and_language"
              }
            />
          ),
          type: "collapse",
         
          icon: RttIcon,
          breadcrumbs: false,
          children:[ {
            id: "Languages",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_languages").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_languages")[0][
                          "value"
                        ] || "lbl_languages"
                      : "lbl_languages"
                    : "lbl_languages"
                }
              />
            ),
            type: "item",
            url: "/languages",
            icon: IconLanguage,
            breadcrumbs: false,
          },
          {
            id: "CMS",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_cms").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_cms")[0]["value"] ||
                        "lbl_cms"
                      : "lbl_cms"
                    : "lbl_cms"
                }
              />
            ),
            type: "item",
            url: "/content-management",
            icon: IconBuildingHospital,
            breadcrumbs: false,
          },
          {
            id: "Labels",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_labels").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_labels")[0][
                          "value"
                        ] || "lbl_labels"
                      : "lbl_labels"
                    : "lbl_labels"
                }
              />
            ),
            type: "item",
            url: "/labels",
            icon: IconMessageLanguage,
            breadcrumbs: false,
          },
          {
            id: "Testimonials",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_testimonials").length >
                      0
                      ? adminLabelsName.filter((e) => e.key == "lbl_testimonials")[0][
                          "value"
                        ] || "lbl_testimonials"
                      : "lbl_testimonials"
                    : "lbl_testimonials"
                }
              />
            ),
            type: "item",
            url: "/testimonials",
            icon: IconLetterT,
            breadcrumbs: false,
          },
          {
            id: "Partners",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_partners").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_partners")[0][
                          "value"
                        ] || "lbl_partners"
                      : "lbl_partners"
                    : "lbl_partners"
                }
              />
            ),
            type: "item",
            url: "/partners",
            icon: IconParking,
            breadcrumbs: false,
          },
          {
            id: "Question Answer",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_question_answer")
                        .length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_question_answer")[0][
                          "value"
                        ] || "lbl_question_answer"
                      : "lbl_question_answer"
                    : "lbl_question_answer"
                }
              />
            ),
            type: "item",
            url: "/question-answer",
            icon: IconReceipt,
            breadcrumbs: false,
          },
          ]
        },
        {
          id: "Staff Support",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_staff_support")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_staff_support")[0][
                        "value"
                      ] || "lbl_staff_support"
                    : "lbl_staff_support"
                  : "lbl_staff_support"
              }
            />
          ),
          type: "item",
          url: "/staff-support",
          icon: IconHelp,
          breadcrumbs: false,
          chip: {
            label: staffSupportUnread,
            color: "primary",
          },
        },
        {
          id: "Email Template",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_email_template")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_email_template")[0][
                        "value"
                      ] || "lbl_email_template"
                    : "lbl_email_template"
                  : "lbl_email_template"
              }
            />
          ),
          type: "item",
          url: "/email-template",
          icon: IconMail,
          breadcrumbs: false,
        },
        {
          id: "Setting",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_setting").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_setting")[0][
                        "value"
                      ] || "lbl_setting"
                    : "lbl_setting"
                  : "lbl_setting"
              }
            />
          ),
          type: "item",
          url: "/setting",
          icon: IconSettings,
          breadcrumbs: false,
        },
        {
          id: "Ads",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_ads").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_ads")[0]["value"] ||
                      "lbl_ads"
                    : "lbl_ads"
                  : "lbl_ads"
              }
            />
          ),
          type: "item",
          url: "/ads",
          icon: IconAd,
          breadcrumbs: false,
        },
       
       
 
            {
        id: "Chat",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_chat").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_chat")[0]["value"] ||
                    "lbl_chat"
                  : "lbl_chat"
                : "lbl_chat"
            }
          />
        ),
        type: "item",
        url: "/chat",
        icon: IconMessages,
        breadcrumbs: false,
        chip: {
          label: unreadChats,
          color: "primary",
        },
      },
      {
        id: "Contact Us",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_contact_us").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_contact_us")[0][
                      "value"
                    ] || "lbl_contact_us"
                  : "lbl_contact_us"
                : "lbl_contact_us"
            }
          />
        ),
        type: "item",
        url: "/contact-us",
        icon: IconMail,
        breadcrumbs: false,
      },

    
      
  
    
     
      
      ]
      },
      {
        id: "company",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_company").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_company")[0][
                      "value"
                    ] || "lbl_company"
                  : "lbl_company"
                : "lbl_company"
            }
          />
        ),
        type: "collapse",
       
        icon: ViewCompactAltIcon,
        breadcrumbs: false,
        children:[
       
          {
            id: "Staff",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_staff").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_staff")[0][
                          "value"
                        ] || "lbl_staff"
                      : "lbl_staff"
                    : "lbl_staff"
                }
              />
            ),
            type: "item",
            url: "/staff",
            icon: IconUsers,
            breadcrumbs: false,
          },
      {
        id: "Subscription",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_subscriptions")
                    .length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_subscriptions")[0][
                      "value"
                    ] || "lbl_subscriptions"
                  : "lbl_subscriptions"
                : "lbl_subscriptions"
            }
          />
        ),
        type: "item",
        url: "/subscription",
        icon: IconShoppingCart,
        breadcrumbs: false,
      },
    ]}
      
     


      // {
      //   id: "Tenant List",
      //   title: (
      //     <FormattedMessage
      //       id={
      //         adminLabelsName
      //           ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list").length >
      //             0
      //             ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list")[0][
      //                 "value"
      //               ] || "lbl_tenant_list"
      //             : "lbl_tenant_list"
      //           : "lbl_tenant_list"
      //       }
      //     />
      //   ),
      //   type: "item",
      //   url: "/tenant-list",
      //   icon: IconBuildingCommunity,
      //   breadcrumbs: false,
      // },
    
      // {
      //   id: "Notification",
      //   title: (
      //     <FormattedMessage
      //       id={
      //         adminLabelsName
      //           ? adminLabelsName.filter((e) => e.key == "lbl_notification").length >
      //             0
      //             ? adminLabelsName.filter((e) => e.key == "lbl_notification")[0][
      //                 "value"
      //               ] || "lbl_notification"
      //             : "lbl_notification"
      //           : "lbl_notification"
      //       }
      //     />
      //   ),
      //   type: "item",
      //   url: "/notification",
      //   icon: IconBellRinging,
      //   breadcrumbs: false,
      //   chip: {
      //     label: unreads,
      //     color: "primary",
      //   },
      // },


     
      
    
 
  
     
   

     


    ],
  };

  const staff = {
    id: "sample-docs-roadmap",
    type: "group",
    role: "Staff",
    children: [
      {
        id: "Users",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_users").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_users")[0][
                      "value"
                    ] || "lbl_users"
                  : "lbl_users"
                : "lbl_users"
            }
          />
        ),
        type: "collapse",
       
        icon: IconUsers,
        breadcrumbs: false,
        children:[
          {
            id: "Tenants",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_tenants").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_tenants")[0][
                          "value"
                        ] || "lbl_tenants"
                      : "lbl_tenants"
                    : "lbl_tenants"
                }
              />
            ),
            type: "item",
            url:"/users",
            icon: IconUserCheck,
            breadcrumbs: false,
          },
          {
            id: "Property Owner",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_landlords")
                        .length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_landlords")[0][
                          "value"
                        ] || "lbl_landlords"
                      : "lbl_landlords"
                    : "lbl_landlords"
                }
              />
            ),
            type: "item",
            url: "/property-owner",
            icon: IconUserCircle,
            breadcrumbs: false,
          },
        ]
      },
      {
        id: "Properties",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_properties_management").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_properties_management")[0][
                      "value"
                    ] || "lbl_properties_management"
                  : "lbl_properties_management"
                : "lbl_properties_management"
            }
          />
        ),
        type: "collapse",
    
        icon: IconBuildingSkyscraper,
        breadcrumbs: false,
        children: [
          {
            id: "registerProperties",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_register_new_property").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_register_new_property")[0][
                          "value"
                        ] || "lbl_register_new_property"
                      : "lbl_register_new_property"
                    : "lbl_register_new_property"
                }
              />
            ),
            type: "item",
            url: "/property/register",
            icon: IconHome,
            breadcrumbs: false,
          },
        
          {
            id: "AgencyRent",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_agency_rent").length >
                      0
                      ? adminLabelsName.filter((e) => e.key == "lbl_agency_rent")[0][
                          "value"
                        ] || "lbl_agency_rent"
                      : "lbl_agency_rent"
                    : "lbl_agency_rent"
                }
              />
            ),
            type: "item",
            url: "/agency-rent",
            icon: IconReceipt,
            breadcrumbs: false,
          },
          {
            id: "Property Request",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_properties_request")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_properties_request"
                        )[0]["value"] || "lbl_properties_request"
                      : "lbl_properties_request"
                    : "lbl_properties_request"
                }
              />
            ),
            type: "item",
            url: "/property-request",
            icon: IconBuildingSkyscraper,
            breadcrumbs: false,
            chip: {
              label: unread,
              color: "primary",
            },
          },
          {
            id: "Rental Contract",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_rental_contract")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_rental_contract"
                        )[0]["value"] || "lbl_rental_contract"
                      : "lbl_rental_contract"
                    : "lbl_rental_contract"
                }
              />
            ),
            type: "item",
            url: "/rental-contract",
            icon: IconLicense,
            breadcrumbs: false,
          },
          {
            id: "Reported Properties",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_reported_properties")
                        .length > 0
                      ? adminLabelsName.filter(
                          (e) => e.key == "lbl_reported_properties"
                        )[0]["value"] || "lbl_reported_properties"
                      : "lbl_reported_properties"
                    : "lbl_reported_properties"
                }
              />
            ),
            type: "item",
            url: "/reported-properties",
            icon: IconBuildingCommunity,
            breadcrumbs: false,
          },
          
        {
          id: "Property Field",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_property_field")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_property_field")[0][
                        "value"
                      ] || "lbl_property_field"
                    : "lbl_property_field"
                  : "lbl_property_field"
              }
              // id="Property Field"
            />
          ),
          type: "item",
          url: "/property-field",
          icon: IconBuildingCarousel,
          breadcrumbs: false,
        },
        ]
      },
      {
        id: "Control",
        title: (
          <FormattedMessage
            id={
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_control").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_control")[0][
                      "value"
                    ] || "lbl_control"
                  : "lbl_control"
                : "lbl_control"
            }
          />
        ),
        type: "collapse",
       
        icon: IconDeviceNintendo,
        breadcrumbs: false,
        children:[ 
    
        {
          id: "Analytics",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_analytics").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_analytics")[0][
                        "value"
                      ] || "lbl_analytics"
                    : "lbl_analytics"
                  : "lbl_analytics"
              }
            />
          ),
          type: "item",
          url: "/analytics",
          icon: IconDeviceAnalytics,
          breadcrumbs: false,
        },
        {
          id: "text",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_text_and_language").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_text_and_language")[0][
                        "value"
                      ] || "lbl_text_and_language"
                    : "lbl_text_and_language"
                  : "lbl_text_and_language"
              }
            />
          ),
          type: "collapse",
         
          icon: RttIcon,
          breadcrumbs: false,
          children:[{
            id: "Languages",
            title: (
              <FormattedMessage
                id={
                  adminLabelsName
                    ? adminLabelsName.filter((e) => e.key == "lbl_languages").length > 0
                      ? adminLabelsName.filter((e) => e.key == "lbl_languages")[0][
                          "value"
                        ] || "lbl_languages"
                      : "lbl_languages"
                    : "lbl_languages"
                }
              />
            ),
            type: "item",
            url: "/languages",
            icon: IconLanguage,
            breadcrumbs: false,
          },
        {
          id: "CMS",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_cms").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_cms")[0]["value"] ||
                      "lbl_cms"
                    : "lbl_cms"
                  : "lbl_cms"
              }
            />
          ),
          type: "item",
          url: "/content-management",
          icon: IconBuildingHospital,
          breadcrumbs: false,
        },
        {
          id: "Labels",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_labels").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_labels")[0][
                        "value"
                      ] || "lbl_labels"
                    : "lbl_labels"
                  : "lbl_labels"
              }
            />
          ),
          type: "item",
          url: "/labels",
          icon: IconMessageLanguage,
          breadcrumbs: false,
        },
        {
          id: "Testimonials",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_testimonials").length >
                    0
                    ? adminLabelsName.filter((e) => e.key == "lbl_testimonials")[0][
                        "value"
                      ] || "lbl_testimonials"
                    : "lbl_testimonials"
                  : "lbl_testimonials"
              }
            />
          ),
          type: "item",
          url: "/testimonials",
          icon: IconLetterT,
          breadcrumbs: false,
        },
        {
          id: "Partners",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_partners").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_partners")[0][
                        "value"
                      ] || "lbl_partners"
                    : "lbl_partners"
                  : "lbl_partners"
              }
            />
          ),
          type: "item",
          url: "/partners",
          icon: IconParking,
          breadcrumbs: false,
        },
        {
          id: "Question Answer",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_question_answer")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_question_answer")[0][
                        "value"
                      ] || "lbl_question_answer"
                    : "lbl_question_answer"
                  : "lbl_question_answer"
              }
            />
          ),
          type: "item",
          url: "/question-answer",
          icon: IconReceipt,
          breadcrumbs: false,
        },
      ]
    },
        {
          id: "Staff Support",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_staff_support")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_staff_support")[0][
                        "value"
                      ] || "lbl_staff_support"
                    : "lbl_staff_support"
                  : "lbl_staff_support"
              }
            />
          ),
          type: "item",
          url: "/staff-support",
          icon: IconHelp,
          breadcrumbs: false,
          chip: {
            label: staffSupportUnread,
            color: "primary",
          },
        },
        {
          id: "Email Template",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_email_template")
                      .length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_email_template")[0][
                        "value"
                      ] || "lbl_email_template"
                    : "lbl_email_template"
                  : "lbl_email_template"
              }
            />
          ),
          type: "item",
          url: "/email-template",
          icon: IconMail,
          breadcrumbs: false,
        },
        {
          id: "Setting",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_setting").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_setting")[0][
                        "value"
                      ] || "lbl_setting"
                    : "lbl_setting"
                  : "lbl_setting"
              }
            />
          ),
          type: "item",
          url: "/setting",
          icon: IconSettings,
          breadcrumbs: false,
        },
        {
          id: "Ads",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_ads").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_ads")[0]["value"] ||
                      "lbl_ads"
                    : "lbl_ads"
                  : "lbl_ads"
              }
            />
          ),
          type: "item",
          url: "/ads",
          icon: IconAd,
          breadcrumbs: false,
        },
        {
          id: "Chat",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_chat").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_chat")[0]["value"] ||
                      "lbl_chat"
                    : "lbl_chat"
                  : "lbl_chat"
              }
            />
          ),
          type: "item",
          url: "/chat",
          icon: IconMessages,
          breadcrumbs: false,
          chip: {
            label: unreadChats,
            color: "primary",
          },
        },
        {
          id: "Contact Us",
          title: (
            <FormattedMessage
              id={
                adminLabelsName
                  ? adminLabelsName.filter((e) => e.key == "lbl_contact_us").length > 0
                    ? adminLabelsName.filter((e) => e.key == "lbl_contact_us")[0][
                        "value"
                      ] || "lbl_contact_us"
                    : "lbl_contact_us"
                  : "lbl_contact_us"
              }
            />
          ),
          type: "item",
          url: "/contact-us",
          icon: IconMail,
          breadcrumbs: false,
        },
       
       

     
      ]
      },

     
    ],
  };

  const menuItem = {
    items: [role === "Admin" ? other : role === "Staff" ? staff : other],
  };
if(matchesXs){
  menuItem.items[0].children.unshift({
      id: "Tenant List",
       title: (
         <FormattedMessage
           id={
             adminLabelsName
              ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list").length >
                 0
                 ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list")[0][
                     "value"
                   ] || "lbl_tenant_list"
                 : "lbl_tenant_list"
               : "lbl_tenant_list"
           }
         />
       ),
       type: "item",
       url: "/tenant-list",
       icon: IconBuildingCommunity,
       breadcrumbs: false,
     })
   menuItem.items[0].children.unshift({
    id: "Dashboard",
     title: (
      <FormattedMessage
         id={
           adminLabelsName
             ? adminLabelsName.filter((e) => e.key == "lbl_dashboard").length > 0
              ? adminLabelsName.filter((e) => e.key == "lbl_dashboard")[0][
                  "value"
                ] || "lbl_dashboard"
              : "lbl_dashboard"
             : "lbl_dashboard"
         }
       />
     ),
     type: "item",

     url: "/dashboard",
     icon: IconClipboardList,
     breadcrumbs: false,
   })
  }

  

  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {
  getNotification,
  notificationAlert,
  getUnreadData,
  getPropertyRequestNotification,
  getStaffSupportNotification,
  getAllChat,
})(memo(MenuList));
